import React, { FC, useEffect }                                                                  from 'react';
import { datadogRum, RumInitConfiguration }                                                      from '@datadog/browser-rum';
import { ENVIRONMENT_IS_PRODUCTION, ENVIRONMENT_IS_STAGING, ENVIRONMENT_LABEL, PRODUCT_VERSION } from '../../../../constants/SystemEnums';

enum DATA_DOG_APP_IDS {
	TEST = '08e63afa-2795-4d9b-98f9-6dc45ff5fa53',
	PROD = '9543ca74-b6e3-4d56-9641-8b347dbf506a',
}

enum DATA_DOG_CLIENT_IDS {
	TEST = 'pub5245886405bd847c4901a003c972853e',
	PROD = 'pube0c814094d45c3ef10746686e85401bb',
}

enum DATA_DOG_SERVICES {
	TEST = 'corval-platform-dev',
	PROD = 'corval-platform',
}

interface DataDogRUMIdentifierProps {
	applicationId?: RumInitConfiguration['applicationId'],
	clientToken?: RumInitConfiguration['clientToken'],
	site?: RumInitConfiguration['site'],
	service?: RumInitConfiguration['service'],
}

const defaultProps: DataDogRUMIdentifierProps = {
	site:          'datadoghq.com',
	applicationId: ( ENVIRONMENT_IS_PRODUCTION || ENVIRONMENT_IS_STAGING ) ? DATA_DOG_APP_IDS.PROD : DATA_DOG_APP_IDS.TEST,
	clientToken:   ( ENVIRONMENT_IS_PRODUCTION || ENVIRONMENT_IS_STAGING ) ? DATA_DOG_CLIENT_IDS.PROD : DATA_DOG_CLIENT_IDS.TEST,
	service:       ( ENVIRONMENT_IS_PRODUCTION || ENVIRONMENT_IS_STAGING ) ? DATA_DOG_SERVICES.PROD : DATA_DOG_SERVICES.TEST,
}

const DataDogRUMIdentifier: FC<DataDogRUMIdentifierProps> = ( props ) => {
	
	useEffect( () => {
		
		let identifierBlock = {
			...props,
			env:                 `${ window.location.hostname }`,
			version:             PRODUCT_VERSION,
			sampleRate:          100,
			defaultPrivacyLevel: 'allow',
			trackInteractions:   true,
			silentMultipleInit:  true,
		}
		
		datadogRum.init( identifierBlock as RumInitConfiguration );
		
		datadogRum.startSessionReplayRecording();
		
	} );
	
	return null;
}

DataDogRUMIdentifier.defaultProps = defaultProps;

export { DataDogRUMIdentifier }
